<template>
  <div>
    <div>
      <!-- {{ checklistValue.id }} -->
      <!-- {{checklistValue}} -->
      <b-row v-if="checklistValue.fieldType == 8">
        <b-col>
          <label>
            <span style="white-space: pre">
              {{ checklistValue.value }}
            </span>
          </label>
        </b-col>
        <b-col v-if="checklistValue.hasOpenPending">
          <span><i class="tim-icons icon-alert-circle-exc"></i></span>
        </b-col>
      </b-row>

      <!-- <b-form-group
        v-else
        :label="getLabel"
        :label-for="'input' + checklistValue.id.toString()"
        label-cols-sm="5"
        label-cols-md="5"
        label-cols-lg="5"
      > -->
      <div v-else-if="checklistValue.fieldType == 22">
        <b-row>
          <b-col lg="3" md="5">
            <label for="">
              {{ getLabel }}
            </label>
          </b-col>
          <b-col lg="5" md="7">
            <b-button size="sm" @click="canShowSubFields"
              ><span v-if="!showSubFields">Mostrar Sub Campos</span>
              <span v-if="showSubFields">Ocultar Sub Campos</span></b-button
            >
          </b-col>
        </b-row>

        <div v-if="showSubFields">
          <!-- {{checklistValue.subChecklist}} -->
          <sub-checklist-filled-details-field
            :subChecklist="checklistValue.subChecklist"
          ></sub-checklist-filled-details-field>
        </div>
      </div>

      <div v-else>
        <b-row>
          <b-col lg="3" md="5" v-if="checklistValue.hasOpenPending">
            <label :for="'input' + checklistValue.id.toString()">
              {{ getLabel }}
              <a
                href="#"
                @click="openPendencyModal(checklistValue.id, getLabel)"
              >
                <i class="danger tim-icons icon-alert-circle-exc"></i>
              </a>
            </label>
          </b-col>

          <b-col lg="3" md="5" v-else>
            <label for="">
              {{ getLabel }}
            </label>
          </b-col>

          <b-col lg="5" md="7">
            <b-input-group
              v-if="
                checklistValue.fieldType == 10 || checklistValue.fieldType == 11
              "
            >
              <div v-if="checklistValue.hasAttachment">
                <b-button
                  v-if="!isShowingAttachment"
                  size="sm"
                  @click="showAttachment()"
                >
                  {{ $t("geral.showAttachments") }}
                </b-button>
                <b-button
                  v-if="isShowingAttachment"
                  size="sm"
                  @click="hideAttachment()"
                >
                  {{ $t("geral.hideAttachments") }}
                </b-button>
              </div>
            </b-input-group>

            <b-input-group v-else>
              <!-- Booleano -->
              <!-- <b-form-select
                v-if="checklistValue.fieldType == 1 && fieldId"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                :name="'input' + checklistValue.id.toString()"
                value="true"
                unchecked-value="false"
                disabled
                :options="optionsBoolean"
              ></b-form-select> -->
              <b-form-select
                v-if="checklistValue.fieldType == 1"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                :name="'input' + checklistValue.id.toString()"
                value="true"
                unchecked-value="false"
                disabled
                :options="optionsBoolean"
              ></b-form-select>

              <!-- Data -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 2"
                type="date"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <!-- Hora -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 3"
                type="time"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <!-- Decimal -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 4"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                v-mask="'money'"
                readonly
              />

              <!-- Inteiro -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 5"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                v-mask="'999999999999999'"
                readonly
              />

              <!-- Texto -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 6"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <!-- Lista -->

              <b-form-input
                v-else-if="checklistValue.fieldType == 7"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.formatedValue"
                readonly
              />

              <b-form-input
                v-else-if="checklistValue.fieldType == 9"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <b-form-input
                v-else
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <!-- <b-form-input
                v-if="checklistValue.id == 2889578 "
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              /> -->

              <b-input-group-append v-if="checklistValue.hasAttachment">
                <b-button v-if="!isShowingAttachment" @click="showAttachment">
                  <i class="tim-icons icon-attach-87"></i>
                </b-button>
                <b-button v-if="isShowingAttachment" @click="hideAttachment">
                  <i class="tim-icons icon-attach-87"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <!-- </b-form-group> -->

      <b-tooltip
        v-if="checklistValue.formatedValue != ''"
        :target="'input' + checklistValue.id.toString()"
        triggers="hover"
      >
        {{ checklistValue.formatedValue }}
      </b-tooltip>
      <b-tooltip
        v-else
        :target="'input' + checklistValue.id.toString()"
        triggers="hover"
      >
        {{ checklistValue.value }}
      </b-tooltip>
    </div>
    <div>
      <b-row>
        <b-col xl="3" lg="2" md="12" sm="12"></b-col>
        <b-col xl="9" lg="10" md="12" sm="12">
          <b-row v-if="isShowingAttachment">
            <b-col
              lg="6"
              md="6"
              sm="12"
              v-for="(attachment, rowAttachment) in checklistValue.attachments"
              :key="rowAttachment"
            >
              <!-- {{ attachment }} -->
              <div v-if="isAttachmentImage(attachment)">
                <base-attachment-viewer
                  v-if="isAttachmentLocal(attachment)"
                  class="ml-3 mb-3"
                  :attachment="attachment"
                  :attachments="checklistValue.attachments"
                  :discard-visible="false"
                  :field-value="checklistValue"
                  :token="token"
                ></base-attachment-viewer>
                <authed-image
                  v-else
                  id="authed-image"
                  :attachmentSrc="
                    `${$store.getters.urlChecklist}/v8/checklist/value/attachment/${attachment.id}`
                  "
                  :attachmentId="attachment.id"
                  :attachmentName="attachment.attachmentName"
                  :discard-visible="false"
                  :token="$store.getters.token"
                ></authed-image>
              </div>
              <div v-else-if="isAttachmentVideo(attachment)">
                <authed-video
                  id="authed-video"
                  :attachmentSrc="attachment.attachment"
                  :attachmentUrl="
                    `${$store.getters.urlChecklist}/v8/checklist/value/attachment/${attachment.id}`
                  "
                  :attachmentId="attachment.id"
                  :attachmentName="attachment.attachmentName"
                  :discard-visible="false"
                  :token="$store.getters.token"
                ></authed-video>
              </div>
              <div v-else>
                <authed-document
                  id="authed-video"
                  :attachmentSrc="
                    `${$store.getters.urlChecklist}/v8/checklist/value/attachment/${attachment.id}`
                  "
                  :attachmentId="attachment.id"
                  :attachmentName="attachment.attachmentName"
                  :attachment="attachment.attachment"
                  :discard-visible="false"
                  :token="$store.getters.token"
                ></authed-document>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <pendency-modal
      ref="pendencyModal"
      @approvalPendency="approvalPendency"
    ></pendency-modal>
  </div>
</template>
<script>
import AuthedDocument from "@/components_rms/base/AuthedDocument.vue";
import AuthedImage from "@/components_rms/base/AuthedImage.vue";
import AuthedVideo from "@/components_rms/base/AuthedVideo.vue";
import AwesomeMask from "awesome-mask";
import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";

export default {
  name: "FilledDetails",
  props: {
    checklistValue: Object,
    label: String
  },
  components: {
    AuthedDocument,
    AuthedImage,
    AuthedVideo,
    BaseAttachmentViewer,
    PendencyModal: () =>
      import("@/components_rms/checklist/pendency/PendencyModal.vue"),
    subChecklistFilledDetailsField: () =>
      import("./SubChecklistFilledDetailsField.vue")
  },
  directives: {
    mask: AwesomeMask
  },
  data: function() {
    return {
      // fullscreenAttachment: "",
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "NÃ£o" }
      ],
      isShowingAttachment: false,
      showSubFields: false
    };
  },
  created: function() {},
  computed: {
    getLabel() {
      if (this.label && this.label.length > 0) return this.label;
      if (this.checklistValue) return this.checklistValue.fieldName;
      return ";";
    }
  },
  methods: {
    approvalPendency() {
      this.checklistValue.hasOpenPending = false;
    },
    isAttachmentImage(attachment) {
      if (attachment.attachmentName.endsWith(".jpeg")) return true;
      if (attachment.attachmentName.endsWith(".jpg")) return true;
      if (attachment.attachmentName.endsWith(".png")) return true;
      return false;
    },
    isAttachmentLocal(ckAttach) {
      if (ckAttach.attachment == null) return false;
      if (ckAttach.attachment == "") return false;
      return true;
    },
    isAttachmentVideo(attachment) {
      return attachment.attachmentName.endsWith(".mp4");
    },
    hideAttachment() {
      if (!this.checklistValue) return;
      if (!this.checklistValue.hasAttachment) return;
      this.isShowingAttachment = false;
      this.$emit("after-attachment-show");
    },
    openPendencyModal(valueId, fieldName) {
      this.$refs.pendencyModal.show(valueId, fieldName);
    },
    canShowSubFields() {
      this.showSubFields = !this.showSubFields;
    },
    showAttachment() {
      if (!this.checklistValue) return;
      if (!this.checklistValue.hasAttachment) return;

      this.isShowingAttachment = true;
      this.$emit("after-attachment-show");

      // if (!this.isShowingAttachment) return;
      // // if (this.checklistValue.attachment) return;
      // //    /checklist/attachment/{attachmentId}

      // this.checklistValue.attachments.forEach((ckAttach) => {
      //   if (!ckAttach.attachment) {
      //     let urlAttachment;
      //     if (ckAttach.id)
      //       urlAttachment = `/checklist/value/attachment/${this.checklistValue.id}/${ckAttach.id}`;
      //     else
      //       urlAttachment = `/checklist/value/attachment/${this.checklistValue.id}`;

      //     this.$apiChecklist
      //       .request({
      //         url: urlAttachment,
      //         method: "GET",
      //         responseType: "arraybuffer", //important
      //       })
      //       .then((response) => {
      //         const base64 = btoa(
      //           new Uint8Array(response.data).reduce(
      //             (data, byte) => data + String.fromCharCode(byte),
      //             ""
      //           )
      //         );
      //         ckAttach.attachment = `data:image/png;charset=utf-8;base64,${base64}`;

      //         // ckAttach.attachment = window.URL.createObjectURL(
      //         //   new Blob([response.data], {
      //         //     type: response.headers["content-type"],
      //         //   })
      //         // );
      //       })
      //       .catch((error) => {
      //         console.log(error);
      //         console.log(error.response.data.errors);
      //         if (error.response.status == 400) {
      //           console.log(error.response.data.errors);
      //         }
      //       });
      //   }
      // });
    }
    // openImage(attachment) {
    //   this.fullscreenAttachment = attachment;
    //   this.$refs.fullscreenSidebar.open();
    // },
  }
};
</script>
<style scoped>
.imagem {
  margin-left: 40%;
}

.iconPendencies {
  position: relative;
  color: #fd5d93;
}

.danger {
  color: #fd5d93;
}

.hasPendency {
  border-color: #fd5d93 !important;
}
</style>

